<template>
	<div class="home">
		<app-banner
			:banners="banners"
			:categories="eCategories"
			:type="bannerTypes.Home"
		/>
		<app-filters
			:filters="filters"
			@filter-selected="filterSelected"
		/>
		<products-by-category
			v-loading="isLoading"
			:is-loading="isLoading"
			v-for="category in categories"
			:key="category.id"
			:category="category"
			:products="category.products"
		></products-by-category>
		<app-footer/>
		<!-- <a class="btn-whatsapp" href="https://api.whatsapp.com/send?phone=" target="_blank">
			<img src="/static/img/icons/whatsapp.svg" alt="logo-whatsapp">
		</a> -->
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { priceProductConfiguration } from '@/helpers/helper';

function created() {
	this.loadCategories();
	this.objUser = this.getLocalStorage('user-info');
	if (this.objUser) {
		this.idCommerce = this.objUser.commerce ? this.objUser.commerce.id : '';
	}
	const id = this.idCommerce || this.getCommerceData.id;
	this.loadData(id);
}

async function loadData(id) {
	const params = {
		commerceId: id,
	};
	const requests = [
		this.$httpQtc.get('banners-public', { params }),
		this.$httpQtc.get('e-categories-public', { params }),
		this.$httpQtc.get('filters-public'),
	];
	([
		{ data: this.banners },
		{ data: this.eCategories },
		{ data: this.filters },
	] = await Promise.all(requests));
	this.$bus.$emit('categories-data', this.eCategories);
	const filterExist = this.getLocalStorage('filter-products');
	if (filterExist) {
		this.filterSelected(filterExist);
		this.filters = this.filters.map((f) => {
			const newF = { ...f };
			newF.active = false;
			if (newF.id === filterExist.id) {
				newF.active = true;
			}
			return newF;
		});
		this.removeLocalData('filter-products');
	}
	this.setPageTitle(this.getTitlePage);
	this.updateDescriptionTag(this.descriptionPage);
}

async function filterProducts() {
	const queryIds = this.queryProducts.join(',');
	const publicUrl = `products-public?filters=${queryIds}`;
	const privateUrl = `products/favorites?filters=${queryIds}`;
	const url = this.token ? privateUrl : publicUrl;
	const privateHeaders = {
		Authorization: `Bearer ${this.token}`,
	};
	const headers = this.token ? privateHeaders : null;
	const { data: products } = await this.$httpQtc.get(url, { headers });
	this.$store.commit('SET_PRODUCTS', products);
}

function filterSelected({ id }) {
	if (this.queryProducts.length === 0) {
		this.queryProducts.push(id);
		this.filterProducts();
	} else {
		const index = this.queryProducts.findIndex(itemId => itemId === id);
		if (index === -1) {
			this.queryProducts = this.queryProducts.concat(id);
			this.filterProducts();
		} else {
			this.queryProducts.splice(index, 1);
			if (this.queryProducts.length > 0) {
				this.filterProducts();
			}
		}
	}
}

function beforeDestroy() {
	window.removeEventListener('scroll', this.scrollHandler);
}

function beforeRouteLeave(to, from, next) {
	this.$store.dispatch('loading', true);
	next();
}

async function loadCategories() {
	this.isLoading = true;
	const headersToken = this.token || this.$store.state.publicToken;
	const headers = {
		Authorization: `Bearer ${headersToken}`,
	};
	const publicService = 'products-public';
	const privateService = 'products';
	const urlService = this.token ? privateService : publicService;
	const params = {
		flagGrouper: this.flagGrouper,
		sortDirection: 'asc',
		sortField: 'order',
	};
	try {
		({ data: this.categories } = await this.$httpQtc.get(`${urlService}/by-ecategories`,
			{ headers, params }));
		this.updateProductsByCategories(this.categories);
	} catch (err) {
		if (err.response.status === 500) {
			this.$message({
				message: 'Ocurrió un error en el servidor.',
				type: 'error',
				showClose: true,
			});
		} else if (err.response.status === 400) {
			if (err.response.data.message === 'LIMIT_VISITS_NOT_CONFIGURED') {
				this.$message({
					message: 'No se ha configurado el límite de visitas para mostrar productos por categorías.',
					type: 'error',
					showClose: true,
				});
			}
		}
	} finally {
		this.isLoading = false;
	}
}

function updateProductsByCategories(categories) {
	const salPriceId = this.getCommerceData.settings.salPriceListId;
	this.categories = categories.map((category) => {
		const newCategory = category;
		newCategory.products = priceProductConfiguration(salPriceId, category.products);
		return newCategory;
	});
}

function data() {
	return {
		banners: [],
		categories: [],
		objUser: {},
		eCategories: [],
		filters: [1, 2],
		queryProducts: [],
		idCommerce: null,
	};
}

function getCommerceData(value) {
	this.objUser = this.getLocalStorage('user-info');
	if (this.objUser) {
		this.idCommerce = this.objUser.commerce ? this.objUser.commerce.id : '';
	}
	if (value) {
		const id = this.idCommerce || value.id;
		this.loadData(id);
	}
}

export default {
	name: 'Home',
	beforeDestroy,
	beforeRouteLeave,
	components: {
		appBanner: () => import('@/sections/Banner'),
		appFilters: () => import('@/sections/Filters'),
		appFooter: () => import('@/sections/Footer'),
		productsByCategory: () => import('@/components/products-by-category'),
	},
	computed: {
		...mapGetters([
			'allProductsLoaded',
			'bannerTypes',
			'flagGrouper',
			'getSearchParams',
			'getTitlePage',
			'token',
			'getCommerceData',
		]),
	},
	created,
	data,
	methods: {
		filterProducts,
		filterSelected,
		loadCategories,
		loadData,
		updateProductsByCategories,
	},
	watch: {
		getCommerceData,
	},
};
</script>
<style lang="scss" scoped>

	@media screen and (min-width: 767px) {
		.new-stuff {
			display: none;
		}
	}

	.btn-whatsapp {
		display: none;

		@media (max-width: 800px) {
			bottom: 5%;
			display: block;
			height: 7rem;
			position: fixed;
			right: 5%;
			width: 7rem;
			z-index: 99;

			img {
				height: 100%;
				width: 100%;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// Home.vue?761efbf3